import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getStats } from '@services/admin.service'
import './Dashboard.scss'

function formatDate(iso) {
  if (!iso) return '—'
  const d = new Date(iso)
  return d.toLocaleDateString('ro-RO', { day: '2-digit', month: 'short', year: 'numeric' })
}

function formatMoney(amount) {
  return new Intl.NumberFormat('ro-RO', { style: 'currency', currency: 'RON' }).format(amount ?? 0)
}

export default function AdminDashboard() {
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    async function load() {
      try {
        const res = await getStats()
        if (!cancelled && res?.data) setStats(res.data)
      } catch (e) {
        if (!cancelled) setError(e.response?.data?.message || e.message || 'Eroare la încărcare')
      } finally {
        if (!cancelled) setLoading(false)
      }
    }
    load()
    return () => { cancelled = true }
  }, [])

  if (loading) return <div className="admin-page">Se încarcă...</div>
  if (error) return <div className="admin-page admin-page--error">{error}</div>
  if (!stats) return null

  const { totalOrders, totalRevenue, totalProducts, totalSubscribers, recentOrders } = stats

  return (
    <div className="admin-page">
      <div className="dashboard-cards">
        <div className="dashboard-card">
          <span className="dashboard-card__label">Total comenzi</span>
          <span className="dashboard-card__value">{totalOrders}</span>
        </div>
        <div className="dashboard-card">
          <span className="dashboard-card__label">Venit total</span>
          <span className="dashboard-card__value">{formatMoney(totalRevenue)}</span>
        </div>
        <div className="dashboard-card">
          <span className="dashboard-card__label">Produse active</span>
          <span className="dashboard-card__value">{totalProducts}</span>
        </div>
        <div className="dashboard-card">
          <span className="dashboard-card__label">Abonați</span>
          <span className="dashboard-card__value">{totalSubscribers}</span>
        </div>
      </div>

      <div className="admin-card">
        <h2 className="dashboard-section__title">Comenzi recente</h2>
        {recentOrders && recentOrders.length > 0 ? (
          <table className="admin-table">
            <thead>
              <tr>
                <th>Nr. comandă</th>
                <th>Client</th>
                <th>Total</th>
                <th>Status</th>
                <th>Data</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {recentOrders.map((o) => (
                <tr key={o.id}>
                  <td>{o.order_number}</td>
                  <td>{[o.customer_first_name, o.customer_last_name].filter(Boolean).join(' ')}</td>
                  <td>{formatMoney(o.total_amount)}</td>
                  <td>
                    <span className={`admin-badge status-${o.status}`}>{o.status}</span>
                    {' '}
                    <span className={`admin-badge status-${o.payment_status}`}>{o.payment_status}</span>
                  </td>
                  <td>{formatDate(o.created_at)}</td>
                  <td>
                    <Link to={`/admin/orders/${o.id}`}>Detalii</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>Nicio comandă recentă.</p>
        )}
      </div>
    </div>
  )
}
